import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {
  Container,
} from 'reactstrap';
import Marketing2Container from '../../components/Marketing2/Marketing2Container';

class Marketing2 extends Component {

  render() {
    return (<Container fluid>
      {/* <h1>Marketing</h1> */}
      <Marketing2Container {...this.props} />
    </Container>)
  }
}

export default Marketing2;
